import React from 'react';
import PatientFormTemplate from './components/PatientFormTemplate';

export default function PatientLifestyleHistoryForm() {
    return (
        <PatientFormTemplate formTitle="Your Lifestyle" />
    );
}